import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import Teams from "../../Template/Home/Teams/Teams";
import { categoriesURL, teamsURL } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";
import useDelete from "../../Hooks/useDelete";

function TeamsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [Open, setOpen] = useState(false);

  const [teams, setTeams] = useState([]);
  const [teamDeleted, setTeamDeleted] = useState("");
  const [deletedSuccess, setDeletedSuccess] = useState(false);
  const { data, loading, error } = useFetch(teamsURL);
  const {
    data: teamsData,
    loading: teamsLoading,
    error: teamsError,
  } = useFetchWhen(teamsURL, deletedSuccess, setDeletedSuccess);

  const { state: deleteRes } = useDelete(
    `${teamsURL}/${teamDeleted}`,
    teamDeleted,
    null,
    null,
    null,
    "",
    setTeamDeleted
  );

  useEffect(() => {
    if (deleteRes?.data?.status == "success") setDeletedSuccess(true);
  }, [deleteRes]);

  useEffect(() => {
    if (!loading && !error && data) {
      setTeams(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!teamsLoading && !teamsError && teamsData) {
      setTeams(teamsData.data);
    }
  }, [teamsData, teamsLoading, teamsError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "teams", data: "" });
  }, []);

  return (
    <Teams
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      teams={teams}
      setTeams={setTeams}
      navigate={navigate}
      Open={Open}
      setOpen={setOpen}
      loading={teamDeleted ? teamsLoading : loading}
      setFilter={setFilter}
      setTeamDeleted={setTeamDeleted}
    />
  );
}

export default TeamsPage;
